const initState = {
  isLoading: false,
};
type LoadingType = {
  isLoading: boolean;
};

export const loadingReducer = (
  state: LoadingType = initState,
  action: LoadingActionType
): LoadingType => {
  // fix any
  switch (action.type) {
    // пишет студент  // need to fix
    case "CHANGE_LOADING":
      return { ...state, isLoading: action.isLoading };
    default:
      return state;
  }
};

type LoadingActionType = {
  type: "CHANGE_LOADING";
  isLoading: boolean;
};

export const loadingAC = (isLoading: boolean): LoadingActionType => ({
  type: "CHANGE_LOADING",
  isLoading,
});
